import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Chat from '../Chat';
import Conversation from '../Conversation';
import Ticket from '../Ticket';
import Layout from '../../layouts/Layout';
import Login from '../Login';
import AuthProvider from '../../providers/auth.provider';
import RequireAuth from '../../components/RequireAuth';
import APIErrorNotification from '../../components/APIErrorNotification';
import APIErrorProvider from '../../providers/apiError.provider';
import Managers from '../Managers';
import Businesses from '../Businesses';
import AuthLayout from '../../layouts/AuthLayout';
import PasswordRecovery from '../PasswordRecovery';
import PasswordReset from '../PasswordReset';
import FormPage from '../FormPage';
import FormResponse from '../FormResponse';
import FormResponseLayout from '../../layouts/FormResponseLayout';
import FormResponseDetail from '../FormResponseDetail';
import PublicForm from '../PublicForm';
import PublicFormProvider from '../../providers/publicForm.provider';
import ReportTicket from '../ReportTicket';
import ChatbotData from '../Chatbot';
import ReportLayout from '../../layouts/ReportLayout';
import ChatbotLayout from '../../layouts/ChatbotLayout';
import ReportForm from '../ReportForm';
import ReportConversation from '../Report Conversation';

export default function App() {
  return (
    <AuthProvider>
      <APIErrorProvider>
        <BrowserRouter basename="/">
          <APIErrorNotification />
          <Routes>
            <Route
              path="/"
              element={
                <RequireAuth>
                  <Layout />
                </RequireAuth>
              }>
              <Route path="/" element={<Navigate to="/managers" />} />
              <Route path="managers" element={<Managers />} />
              <Route path="businesses" element={<Businesses />} />
              <Route path="chatbot/:unitId/tickets" element={<Ticket />} />
              <Route path="chatbot/:unitId/tickets/:ticketId" element={<Chat />} />
              <Route path="forms" element={<FormPage />} />
              <Route path="/forms/:formTypeId/responses" element={<FormResponseLayout />}>
                <Route path="" element={<FormResponse />} />
                <Route path=":formResponseId" element={<FormResponseDetail />} />
              </Route>
              <Route path="/reports" element={<ReportLayout />}>
                <Route path="" element={<Navigate to="./tickets" />} />
                <Route path="tickets" element={<ReportTicket />} />
                <Route path="forms" element={<ReportForm />} />
                <Route path="conversations" element={<ReportConversation />} />
              </Route>
              <Route path="/reports/conversations/:conversationId" element={<Conversation />} />
              <Route path="/chatbot" element={<ChatbotLayout />}>
                <Route path="" element={<Navigate to="./data" />} />
                <Route path="data" element={<ChatbotData />} />
              </Route>
            </Route>
            <Route path="/auth" element={<AuthLayout />}>
              <Route path="login" element={<Login />} />
              <Route path="password-recovery" element={<PasswordRecovery />} />
              <Route path="password-reset" element={<PasswordReset />} />
            </Route>
            <Route
              path="/public/forms/:formTypeId"
              element={
                <PublicFormProvider>
                  <PublicForm />
                </PublicFormProvider>
              }
            />
          </Routes>
        </BrowserRouter>
      </APIErrorProvider>
    </AuthProvider>
  );
}
